import React from "react";
import { EventButton } from "../common";

const InfoExpiredScreen = ({ onGoHome }) => {
  return (
    <div className="newyear-info-expired">
      <div className="newyear-info-expired__icon">
        <span className="newyear-info-expired__emoji">
          &#9201;
        </span>
      </div>

      <h2 className="newyear-info-expired__title">입력 기한 만료</h2>
      <p className="newyear-info-expired__message">
        당첨자 정보 입력 기한이 만료되었습니다.
      </p>

      <p className="newyear-info-expired__sub-message">
        기한 내 정보를 입력하지 않아 당첨이 취소되었습니다.
      </p>

      {onGoHome && (
        <div className="newyear-info-expired__actions">
          <EventButton
            variant="secondary"
            size="large"
            fullWidth
            onClick={onGoHome}
          >
            홈으로 돌아가기
          </EventButton>
        </div>
      )}
    </div>
  );
};

export default InfoExpiredScreen;
